import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';

const ChatHistoryLoader = () => {
  return (
    <Box
      sx={{ p: 2, width: '100%', margin: 'auto' }}
      data-testid="chat-history-loader"
    >
      <Stack
        direction="row"
        spacing={2}
        justifyContent="flex-end"
        alignItems={'center'}
        sx={{ mb: 2 }}
        data-testid="chat-loader-user-message"
      >
        <Skeleton
          variant="text"
          data-testid="user-message-skeleton"
          sx={{
            width: '50%',
            padding: { sm: '16px 20px', xs: '10px 15px' },
            borderRadius: '16px',
          }}
        />
        <Skeleton
          variant="circular"
          data-testid="user-avatar-skeleton"
          sx={{
            height: '40px',
            width: '40px',
          }}
        >
          <Avatar />
        </Skeleton>
      </Stack>
      <Stack spacing={1.5} data-testid="chat-loader-ai-response">
        <Typography variant="body2">
          <Skeleton
            width="70%"
            data-testid="ai-response-skeleton-1"
            sx={{
              padding: { sm: '12px 16px', xs: '8px 12px' },
            }}
          />
          <Skeleton
            sx={{
              padding: { sm: '12px 16px', xs: '8px 12px' },
            }}
            width="90%"
            data-testid="ai-response-skeleton-2"
          />
          <Skeleton
            sx={{
              padding: { sm: '12px 16px', xs: '8px 12px' },
            }}
            width="80%"
            data-testid="ai-response-skeleton-3"
          />
        </Typography>

        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          data-testid="feedback-buttons-skeleton"
        >
          <Skeleton
            variant="rectangular"
            sx={{ borderRadius: '100%' }}
            width={28}
            height={28}
            data-testid="feedback-button-skeleton-1"
          />
          <Skeleton
            variant="rectangular"
            sx={{ borderRadius: '100%' }}
            width={28}
            height={28}
            data-testid="feedback-button-skeleton-2"
          />
          <Skeleton
            variant="rectangular"
            sx={{ borderRadius: '100%' }}
            width={28}
            height={28}
            data-testid="feedback-button-skeleton-3"
          />
          <Skeleton
            variant="rectangular"
            sx={{ borderRadius: '100%' }}
            width={28}
            height={28}
            data-testid="feedback-button-skeleton-4"
          />
        </Stack>

        <Typography variant="caption">
          <Skeleton width="20%" data-testid="timestamp-skeleton" />
        </Typography>

        <Skeleton
          variant="rectangular"
          width={160}
          height={48}
          sx={{ borderRadius: '10px' }}
          data-testid="deep-link-button-skeleton"
        />
      </Stack>
    </Box>
  );
};
export default ChatHistoryLoader;
